import { BrokenImage } from '@components/index';
import styled from 'styled-components';

export const InputDropDownWrapper = styled.div`
  position: absolute;
  padding: 12px 16px 16px 16px;
  height: fit-content;
  background: #ffffff;
  border: 1px solid #d8dae5;
  border-top: none;
  box-shadow: 0px 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 0px 0px 8px 8px;
  z-index: 1;
  width: 100%;
`;

export const Suggested = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
  margin: unset;
  cursor: pointer;
`;

export const Quote = styled.q`
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
  margin: unset;
`;

export const Suggestions = styled.ul`
  padding: 0;
  margin: 0;
  margin-top: 18px;
  max-height: 200px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 24px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Suggestion = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 5px 10px;
  border-radius: 8px;
  cursor: pointer;

  :not(:last-child) {
    margin-bottom: 12px;
  }

  :hover {
    background-color: #f6f8ff;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ImagePlaceholder = styled.div`
  min-width: 32px;
  max-width: 32px;
  min-height: 32px;
  max-height: 32px;
  border: 1px solid #d8dae5;
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
`;

export const Image = styled(BrokenImage)`
  object-fit: cover;
  width: 100%;
`;

export const ProductName = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
  margin: unset;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const ProductToolTip = styled.div`
  span {
    display: inline-flex;
  }
`;

export const ProductToolTipText = styled.p`
  color: #fff;
  margin: unset;
`;

export const LoadMore = styled.div`
  margin-top: 6px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: row;
`;

export const LoadMoreContainer = styled.div`
  width: 100%;
`;

export const LoadingText = styled.div`
  border-radius: 8px;
  margin-right: 8px;
  border: none;
  font-size: 12px;
  color: #696f8c;
  text-align: center;
`;

export const LoadingImg = styled.img`
  height: 14px;
  width: 14px;
`;
